import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { FormGroup, Form, Input, Label, Button, Row, Col, Spinner } from "reactstrap";
import { Link, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import ValetApi from "../api/Api";

const ForgotPasswordForm = () => {
    const [loading, setLoading] = useState(false);
    const location = useLocation();
    const isTenantPortal = new URLSearchParams(location.search).get("portal") === "tenant";
    const fieldName = isTenantPortal ? "username" : "email";

    const formik = useFormik({
        initialValues: {
            [fieldName]: "",
        },
        validationSchema: Yup.object({
            [fieldName]: isTenantPortal ? Yup.string().trim().max(100).required("Required") : Yup.string().email("Enter a valid email").required("Required"),
        }),
        onSubmit: async (values, { resetForm }) => {
            setLoading(true);
            try {
                const identifier = values[fieldName].trim().toLowerCase();
                const res = isTenantPortal ? await ValetApi.forgotTenantPassword(identifier) : await ValetApi.forgotPassword(identifier);
                toast.success(res?.data?.message || "If an account exists for that email, a password reset link has been sent.", { autoClose: 2000 });
                resetForm();
            } catch (err) {
                toast.error(err?.[0] || "Unable to process forgot password request", { autoClose: 1200 });
            } finally {
                setLoading(false);
            }
        },
    });

    return (
        <section className="auth-page">
            {loading ? (
                <Spinner color="primary" />
            ) : (
                <Row className="justify-content-center m-0 w-100">
                    <Col
                        xs={12}
                        sm={10}
                        md={6}
                        lg={4}>
                        <div className="auth-card">
                            <h3>{isTenantPortal ? "Tenant Forgot Password" : "Forgot Password"}</h3>
                            <p style={{ marginBottom: "0.75rem", color: "#6b7280", fontSize: "0.92rem" }}>{isTenantPortal ? "A reset link will be sent to your tenant account's contact email." : "Enter your account email and we will send a password reset link."}</p>
                            <Form onSubmit={formik.handleSubmit}>
                                <FormGroup>
                                    <Label htmlFor={fieldName}>{isTenantPortal ? "Tenant Username" : "Email"}</Label>
                                    <Input
                                        id={fieldName}
                                        placeholder={isTenantPortal ? "tenant username" : "enter account email"}
                                        name={fieldName}
                                        type={isTenantPortal ? "text" : "email"}
                                        autoComplete={fieldName}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values[fieldName]}
                                    />
                                    {formik.touched[fieldName] && formik.errors[fieldName] ? <div style={{ color: "red" }}>{formik.errors[fieldName]}</div> : null}
                                </FormGroup>

                                <Button
                                    type="submit"
                                    color="primary"
                                    disabled={loading}>
                                    Send Reset Link
                                </Button>
                            </Form>

                            <div style={{ marginTop: "0.75rem", fontSize: "0.9rem" }}>
                                <Link to={isTenantPortal ? "/tenant/login" : "/login"}>Back to Login</Link>
                            </div>
                        </div>
                    </Col>
                </Row>
            )}
        </section>
    );
};

export default ForgotPasswordForm;
